export default {
    meta: {
        title: 'Apply for a personal loan | Fig Financial',
        description: 'Receive a loan offer within seconds and complete your application in minutes, all from the comfort of your home.'
    },
    home: {
        title: 'Home'
    },
    cta: {
        buttonText: 'Continue',
        disclaimerText: 'This will not impact your credit score',
        disclaimerIconAlt: 'Disclaimer icon'
    },
    loading: {
        title: 'Loading...'
    },
    error: {
        generic: {
            title: 'Oops, something’s gone wrong',
            subtitle:
                'We’re working on fixing this as soon as possible. Click the ‘Try again’ button, or please reach out to us via <liveChatLink>Fig live chat</liveChatLink> to the bottom right of this page or <supportLink>email Fig support</supportLink>.',
            buttonText: 'Try again'
        },
        404: {
            title: "Oops! We couldn't find that page",
            subtitle: 'The page you’re looking for doesn’t exist. Don’t worry — your loan booking progress is safe and you can continue where you left off.',
            goBack: 'Go back',
            contactUs: 'Contact us'
        }
    },
    common: {
        progressBarEstimate: 'Just a few minutes to finish',
        alt: {
            figLogo: 'Fig Logo',
            figEliteLogo: 'Fig Elite logo',
            /** Nav bar when showing partner Q2 logo (a11y) */
            partnerNavLogo: '{{partnerName}} logo',
            kizzoLogo: 'Kizzo Logo',
            partnerLogo: '{{name}} logo',
            verificationFailed: 'Verification Failed',
            handCheckmark: 'Hand Checkmark',
            congratulations: 'Congratulations',
            flinksLogo: 'Flinks',
            successIcon: 'Success',
            loanComplete: 'Loan Complete',
            disclaimer: 'Disclaimer',
            lightbulb: 'Information icon',
            phone: 'Phone icon',
            pencilEdit: 'Edit icon',
            languageFlag: 'Flag icon for the locale switcher',
            notFound: '404 Not Found',
            maintenance: `"We're updating our systems currently"`
        },
        otpSection: {
            resendMessage: "Didn't receive a code?",
            resendButton: 'Resend'
        },
        date: {
            label: 'Date of birth',
            month: 'Month',
            day: 'Day',
            year: 'Year',
            months: {
                1: 'January',
                2: 'February',
                3: 'March',
                4: 'April',
                5: 'May',
                6: 'June',
                7: 'July',
                8: 'August',
                9: 'September',
                10: 'October',
                11: 'November',
                12: 'December'
            }
        },
        FigDatePicker: {
            placeholder: 'Select a date',
            useCalendarWarning: 'Please select a date using the calendar.'
        }
    },
    PleaseReachOut: {
        contactFigLabel: 'email Fig support',
        liveChatLabel: 'Fig live chat',
        content: 'please reach out to us via <2/> to the bottom right of this page or <4/>.'
    },
    maintenance: {
        title: "We're updating our systems currently",
        content:
            'Scheduled maintenance is in progress. During this time, the Fig loan application will be unavailable. <br /> We expect to be back in a few hours. Thank you for your patience.'
    },
    partner: {
        kizzo: 'KIZZO',
        kizzoPoweredBy: 'KIZZO Powered by Fig',
        fig: 'Fig'
    }
}
